import Vue from 'vue'
import TextField from './text-field.vue'
import DatetimeField from './datetime-field.vue'
import LocationField from './location-field.vue'
import CoverField from './cover-field.vue'
import CoverFieldVertical from './cover-field-vertical.vue'
import TextEditorField from './text-editor-field.vue'
import SelectField from './select-field.vue'
import SelectFieldMultiple from './select-field-multiple.vue'
import TextareaField from './textarea-field.vue'
import CounterField from './counter-field.vue'
import ZonePickerField from './zone-picker-field.vue'
import ColorPickerField from './color-picker-field.vue'
import HuePickerField from './hue-picker-field.vue'
import VenueMapField from './venue-map-field.vue'
import LogoField from './logo-field.vue'
import SwitchField from './switch-field.vue'
import AutocompleteField from './autocomplete-field'
import AvatarField from './avatar-field'
import PhoneNumberField from './phone-number-field'
import RadioButton from './radio-button'
import CheckboxGroup from './checkbox-group'
import Checkbox from './checkbox'
import FormSectionLabel from './form-section-label.vue'
import DateField from './date-field.vue'
import TimeField from './time-field.vue'
import RichTextDescriptionLabel from './rich-text-description-label.vue'

Vue.component('text-field', TextField)
Vue.component('datetime-field', DatetimeField)
Vue.component('location-field', LocationField)
Vue.component('cover-field', CoverField)
Vue.component('cover-field-vertical', CoverFieldVertical)
Vue.component('text-editor-field', TextEditorField)
Vue.component('select-field', SelectField)
Vue.component('select-field-multiple', SelectFieldMultiple)
Vue.component('textarea-field', TextareaField)
Vue.component('counter-field', CounterField)
Vue.component('zone-picker-field', ZonePickerField)
Vue.component('color-picker-field', ColorPickerField)
Vue.component('hue-picker-field', HuePickerField)
Vue.component('venue-map-field', VenueMapField)
Vue.component('logo-field', LogoField)
Vue.component('switch-field', SwitchField)
Vue.component('autocomplete-field', AutocompleteField)
Vue.component('avatar-field', AvatarField)
Vue.component('phone-number-field', PhoneNumberField)
Vue.component('radio-button', RadioButton)
Vue.component('checkbox-group', CheckboxGroup)
Vue.component('checkbox', Checkbox)
Vue.component('form-section-label', FormSectionLabel)
Vue.component('date-field', DateField)
Vue.component('time-field', TimeField)
Vue.component('rich-text-description-label', RichTextDescriptionLabel)
